module.exports = __webpack_public_path__ + "img/thermometer-img4-1.db752f1b.png";